import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from '../../helper/controlservice';

import PhoneInput from 'react-phone-number-input'

class Phone extends React.PureComponent {
    state = {
        value: '',
        touched: false
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : null;
        if (nextData && nextData[nextProps.control.key] === undefined && prevState.touched) {
            return {
                value: '',
                touched: false
            };
        } else if (nextData) {
            return {
                value: nextData[nextProps.control.key]
            };
        }
        else return null; // Triggers no change in the state
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value && this.state.value === undefined && this.state.touched === false) {
            this.props.update(this.props.control.key, this.state.value, this.props.formid)
        } else if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    handleBlur = () => {
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control) {
        const validate = ControlService().validate(control, this.state.value);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    componentDidMount() {
        this.setState({ touched: this.state.value ? true : false });

        ControlService().controlVaildationCheck(this.props);
    }
    onValueChange(value, control, action, formid) {

        if (action == 'filter') {
            this.props.updateFilter(control.key, value)
        } else {
            this.props.update(control.key, value, formid)
        }

        var validation = ControlService().validate(control, value);
        var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
        if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }
    }
    render() {
        const { control, action, formid } = this.props;
        const shouldMarkError = this.shouldMarkError(control);
        return (
            <div className="form-group">
                {control.label &&
                    <label className="" htmlFor={control.id}>
                        {control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {control.imageurl &&
                    <img src="control.imageurl" width="100" height="100" alt={column.label} className="mb-2 img-fluid" />
                }
                <PhoneInput
                    defaultCountry={control.defaultCountry ? control.defaultCountry : 'US'}
                    autoComplete="off"
                    placeholder={control.placeholder}
                    id={control.id}
                    required={control.require}
                    className={'form-control p-0 ' + (shouldMarkError ? "border-danger" : "")}
                    onBlur={() => { this.handleBlur(); }}
                    onChange={(e) => this.onValueChange(e, control, action, formid)}
                    value={this.state.value}
                    disabled={this.props.disabled}
                />
                {/* <div className="input-group">
                         {control.label &&
                            <div className="input-group-prepend">
                                <span className="input-group-text"><i className="fa fa-mobile"></i></span>
                            </div>
                        }
                        
                    </div> */}
                {(!this.state.value && shouldMarkError) &&
                    <small className="form-text text-danger">
                        {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                    </small>
                }
                {(this.state.value && shouldMarkError) &&
                    <small className="form-text text-danger">You must include a valid phone number.</small>
                }
                {control.description &&
                    <div className="form-text">{control.description}</div>
                }
            </div>
        );
    }
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
export default connect(mapStateToProps, bindAction)(Phone);